import React from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import LockIcon from "@mui/icons-material/Lock";
import CloseIcon from "@mui/icons-material/Close";
import { Icon, ListSubheader } from "@mui/material";
import { useBuscadorGlobalStyles } from "./styles/BuscadorGlobalStyles";
import { getColorModulo } from "./ColoresModulos";

export const renderizarIcono = (icono, classes, colorModulo) => {
  if (icono && icono.trim() !== "") {
    return (
      <Icon className={classes.iconoMaterial} sx={{ color: colorModulo }}>
        {icono}
      </Icon>
    );
  }
  return <Box component="span" className={classes.iconoMaterialVacio} />;
};

export const ResultadoItem = ({
  item,
  onClick,
  colorModulo,
  onEliminarItem,
  labelSinPermisos,
}) => {
  const classes = useBuscadorGlobalStyles();
  const tienePermiso = !item?.disabled;
  const color = colorModulo ?? getColorModulo(item?.semCode);

  const handleEliminar = (e) => {
    e.stopPropagation();
    if (onEliminarItem && item?.path) onEliminarItem(item.path);
  };

  const listItem = (
    <ListItem
      className={`${classes.itemResultado} ${
        tienePermiso ? "" : classes.itemResultadoDeshabilitado
      }`}
      onClick={tienePermiso ? () => onClick(item) : undefined}
      disableGutters
    >
      <ListItemIcon sx={{ minWidth: 40 }}>
        {renderizarIcono(item?.icono, classes, color)}
      </ListItemIcon>
      <ListItemText
        primary={<Box className={classes.tituloItem}>{item?.titulo}</Box>}
      />
      {item.disabled ? (
        <LockIcon className={classes.iconoLock} fontSize="small" />
      ) : onEliminarItem ? (
        <IconButton
          className={classes.botonEliminar}
          size="small"
          onClick={handleEliminar}
          aria-label="Eliminar"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      ) : null}
    </ListItem>
  );

  if (!tienePermiso) {
    return (
      <Tooltip
        title={labelSinPermisos || "Sin permisos para acceder a este módulo"}
        placement="bottom"
        PopperProps={{
          sx: { zIndex: 10000 },
        }}
      >
        <span style={{ display: "block", pointerEvents: "auto" }}>
          {listItem}
        </span>
      </Tooltip>
    );
  }

  return listItem;
};

export const GrupoModulo = ({
  grupo,
  onItemClick,
  onEliminarItem,
  labelSinPermisos,
}) => {
  const classes = useBuscadorGlobalStyles();
  const colorModulo = getColorModulo(grupo.semCode);

  return (
    <Box className={classes.grupoModulo}>
      <List
        className={classes.listaResultados}
        disablePadding
        subheader={
          <ListSubheader
            component="div"
            sx={{
              fontWeight: 600,
              fontSize: "0.75rem",
              textTransform: "uppercase",
              letterSpacing: "0.8px",
              lineHeight: "40px",
            }}
          >
            {grupo.nombreModulo}
          </ListSubheader>
        }
      >
        {grupo.items.map((item, index) => (
          <ResultadoItem
            key={index}
            item={item}
            onClick={onItemClick}
            colorModulo={colorModulo}
            onEliminarItem={onEliminarItem}
            labelSinPermisos={labelSinPermisos}
          />
        ))}
      </List>
    </Box>
  );
};
